import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import {validateFields, validateField} from './../../../utilities/validation/validator';
import lodash from 'lodash';
import ProviderManager from '../../../provider/providerManager';

export const submitSearching = createAsyncThunk('LawClassActionBlock/submitSearching', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('getLawClassActionResult', [
      data.captchaToken,
      data.customer_id_number,
      data.customer_phone,
      data.searchType,
      data.law_class_action_code,
    ]);
    return {isSuccess: true, rowsCount: result.Body};
  } catch (error) {
    return {isSuccess: false, errorCode: error.errorCode};
  }
});

const LawClassActionBlockSlice = createSlice({
  name: 'lawClassActionBlock',
  initialState: {
    form: {
      id: '',
      phone: '',
      valid: '',
      errors: {
        id: '',
        phone: '',
      },
      rules: {},
    },
    isShowLoader: false,
    showResponse: false,
    showErrorMessage: false,
    lawActionExists: false,
  },
  reducers: {
    validateHandler: {
      reducer(state, action) {
        state.form = action.payload;
      },
      prepare(payload) {
        const validate = validateFields(lodash.cloneDeep(payload));
        return {payload: validate};
      },
    },
    clearIsValid: {
      reducer(state, action) {
        state.form = action.payload;
      },
      prepare(payload) {
        const form = lodash.cloneDeep(payload);
        form.valid = '';
        return {payload: form};
      },
    },
    changeHandler: {
      reducer(state, action) {
        state.showResponse = false;
        state.showErrorMessage = false;
        state.form = action.payload;
      },
      prepare(payload) {
        const name = payload.target.name;
        const value = payload.target.value;
        const form = lodash.cloneDeep(payload.form);
        const validate = validateField(form, name, value);
        return {payload: validate};
      },
    },
  },
  extraReducers: {
    [submitSearching.pending]: (state, action) => {
      state.isShowLoader = true;
      state.lawActionExists = false;
      state.showResponse = false;
      state.showErrorMessage = false;
    },
    [submitSearching.fulfilled]: (state, action) => {
      state.isShowLoader = false;
      if (action.payload.isSuccess) {
        if (action.payload.rowsCount > 0) {
          state.lawActionExists = true;
        }
      } else {
        state.showErrorMessage = true;
      }
      state.showResponse = true;
    },
  },
});

export const {changeHandler, clearIsValid, validateHandler} = LawClassActionBlockSlice.actions;

export default LawClassActionBlockSlice.reducer;
